import '.c3{flex-shrink:0;}.ssr-plugin'
import '.c4{padding:1rem;}.ssr-plugin'
import '.a4{width:100%;}.ssr-plugin'
import '.bk{height:100%;}.ssr-plugin'
import '.bd{border:none;}.ssr-plugin'
import '.be{background-color:transparent;}.ssr-plugin'
import '.fo{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.cu{position:sticky;}.ssr-plugin'
import '.fp{top:4rem;}.ssr-plugin'
import '.fq{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.fr{padding-bottom:1rem;}.ssr-plugin'
import '.x{margin-bottom:1rem;}.ssr-plugin'
import '.fs{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a1{position:fixed;}.ssr-plugin'
import '.cm{top:0;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.ft{bottom:0px;}.ssr-plugin'
import '.ez{z-index:9999;}.ssr-plugin'
import '.fu{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.dr{justify-content:flex-end;}.ssr-plugin'
import '.c5{flex:1;}.ssr-plugin'
import '.ar{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="c3 c4 a4 bk bd be fo"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a m ab"
    >
      <div className="cu fp fq ae fr x fs a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a1 cm bi bj ft ez ae fu a m"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="c4 a dr fs"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="c5 ar">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
